import { connectMenu } from "instantsearch.js/es/connectors";
import { selectArrow } from "./svgs";
import { translate } from "../translate";

const customArrow = `
		<div class="absolute inset-y-0 right-0 flex items-center px-2 mr-2 text-gray-700 pointer-events-none">
			${selectArrow}
		</div> 
`;

/*
	The custom select gives us some freedom with what the HTML output is
 */
// 1. Create a render function
const renderMenuSelect = (renderOptions, isFirstRender) => {
	const { items, canRefine, refine, widgetParams } = renderOptions;
	const { defaultOption, showCount = true, allText = "All" } = widgetParams;

	if (!widgetParams.container) {
		console.warn('menu select widget container is missing');
		return;
	}

	if (isFirstRender) {
		const select = document.createElement('select');

		select.addEventListener('change', event => {
			refine(event.target.value);
		});

		widgetParams.container.appendChild(select);
		widgetParams.container.insertAdjacentHTML("beforeend", customArrow);
	}

	const select = widgetParams.container.querySelector('select');

	select.classList.add('ais-MenuSelect-select', 'appearance-none')
	select.disabled = !canRefine;

	// only add an "All" option if something is refined in this select
	// otherwise instantsearch throws an error when sorting by "All" with nothing selected
	let isRefined = false;
	for (let i = 0; i < items.length; i++) {
		if (items[i] && items[i].isRefined) {
			isRefined = true;
			break;
		}
	}

	/*
		if the order of the facets is incorrect, be sure they are all configured within the alogolia admin
		for the selected index under Configuration / Facets and Facets Display
	 */
	select.innerHTML = `
    ${isRefined ? `<option value="">${translate(allText)}</option>` : `<option value="">${defaultOption}</option>`}
    ${items
		.map(
			item => {
				return (
					`<option
            value="${item.value}"
            ${item.isRefined ? 'selected' : ''}
          >
            ${translate(item.label)} ${(showCount && item.count > 0) ? `(${item.count})` : ''}
          </option>`
				)
			}
		)
		.join('')}
  `;
};

// Create and export the custom widget

export default connectMenu(renderMenuSelect);
